module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB4001-d75fa1ff0f6833170a891debd58f704f.png";